import { S } from '../core/estado.js';
import { esc } from '../core/formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   CONTACTOS
   ---------------------------------------------------------------------
   A quién avisar de un pedido o de un trabajo en este contrato.
   ===================================================================== */
export function tabContactos(cid){
  const lista = db.contactos.filter(c=>c.contrato===cid);
  const puede = S.usuario.rol!=='consulta';
  return `<div class="card"><div class="card-h"><div><h3>Contactos</h3>
    <div class="sub">A quién avisar de pedidos o de trabajos en este contrato</div></div>
    ${puede?`<button class="btn btn-s btn-p" data-act="nuevo-contacto" data-c="${cid}">Añadir contacto</button>`:''}</div>
    <div class="tabla-wrap">${lista.length?`<table>
      <thead><tr><th>Nombre</th><th>Cargo</th><th>Teléfono</th><th>Email</th><th>Observaciones</th>${puede?'<th></th>':''}</tr></thead>
      <tbody>${lista.map(x=>`<tr>
        <td><b>${esc(x.nombre)}</b></td>
        <td>${x.cargo?esc(x.cargo):'—'}</td>
        <td class="mono" style="font-size:12.5px">${x.telefono?esc(x.telefono):'—'}</td>
        <td class="mono" style="font-size:12.5px">${x.email?`<a href="mailto:${esc(x.email)}">${esc(x.email)}</a>`:'—'}</td>
        <td style="font-size:12.5px;color:var(--gris)">${x.obs?esc(x.obs):'—'}</td>
        ${puede?`<td style="white-space:nowrap">
          <button class="btn btn-x" data-act="editar-contacto" data-c="${cid}" data-id="${x.id}">Editar</button>
          <button class="btn btn-x" data-act="borrar-contacto" data-id="${x.id}">Eliminar</button></td>`:''}
      </tr>`).join('')}</tbody></table>`
      :`<div class="vacio"><h4>Sin contactos todavía</h4><p>Apunta a quién avisar cuando se haga un pedido o se ejecute un trabajo.</p></div>`}</div></div>`;
}
